import { TrendingUp, AlertTriangle, Clock, Target } from "lucide-react";

export const DomainWarmupKeyFindings = () => {
  const findings = [
    {
      icon: AlertTriangle,
      iconColor: "text-warning",
      bgColor: "bg-warning/10",
      title: "New Domains Face 40-60% Lower Inbox Rates",
      description: "Email providers treat new domains with suspicion. Without established reputation, emails are more likely to land in spam or be rejected entirely.",
      stat: "40-60%",
      statLabel: "lower initial inbox placement",
      source: "Validity 2025"
    },
    {
      icon: TrendingUp,
      iconColor: "text-success",
      bgColor: "bg-success/10",
      title: "Gradual Volume Increases Build Trust",
      description: "ISPs monitor sending patterns. Domains that gradually increase volume over 4-8 weeks achieve significantly higher long-term deliverability.",
      stat: "4-8 weeks",
      statLabel: "optimal warmup period",
      source: "Lemlist 2024"
    },
    {
      icon: Target,
      iconColor: "text-primary",
      bgColor: "bg-primary/10",
      title: "Engagement Rates Matter More Than Volume",
      description: "High open rates (40%+) and low bounce rates (<2%) during warmup signal legitimacy to ISPs more than the number of emails sent.",
      stat: "40%+",
      statLabel: "target open rate during warmup",
      source: "Mailgun 2024"
    },
    {
      icon: Clock,
      iconColor: "text-info",
      bgColor: "bg-info/10",
      title: "Consistent Daily Sending Outperforms Bursts",
      description: "Sending the same volume daily builds predictable patterns. Sporadic high-volume bursts trigger spam filters and damage reputation.",
      stat: "7 days/week",
      statLabel: "consistent sending recommended",
      source: "Instantly 2024"
    }
  ];

  return (
    <section className="py-8 sm:py-10">
      <div className="mb-6 sm:mb-8">
        <h2 className="font-display text-2xl sm:text-3xl font-bold text-foreground mb-2">
          Why Domain Warmup Matters
        </h2>
        <p className="text-muted-foreground">
          Research-backed findings on building email sender reputation
        </p>
      </div>

      <div className="grid sm:grid-cols-2 gap-4 sm:gap-5">
        {findings.map((finding, index) => (
          <div 
            key={index}
            className="bg-card border border-border rounded-xl p-5 sm:p-6 hover:border-primary/30 transition-colors"
          >
            <div className="flex items-start gap-4">
              <div className={`shrink-0 w-10 h-10 rounded-xl ${finding.bgColor} flex items-center justify-center`}>
                <finding.icon className={`w-5 h-5 ${finding.iconColor}`} />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-display font-semibold text-foreground mb-2">
                  {finding.title}
                </h3>
                <p className="text-sm text-muted-foreground mb-3 leading-relaxed">
                  {finding.description}
                </p>
                <div className="flex items-center gap-3">
                  <div className="bg-muted/50 rounded-lg px-3 py-1.5">
                    <span className="font-display font-bold text-foreground">{finding.stat}</span>
                    <span className="text-xs text-muted-foreground ml-1.5">{finding.statLabel}</span>
                  </div>
                </div>
                <div className="text-xs text-muted-foreground/60 mt-2">
                  Source: {finding.source}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
